'use client'

import styles from './Translations.module.scss'
import { RootContext } from '@/modules/contextService'
import { useTranslations } from 'next-intl'
import {
  useEffect,
  useState,
  useContext,
  forwardRef
  // useRef
} from 'react'
import { PATHWAY } from '@/modules/httpService'
import { redirect } from 'next/navigation'
import Row from './Row'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

function Page ({ params }: { params: { slug: string }}) {
  const { rootData } = useContext(RootContext)
  const { user } = rootData
  const t = useTranslations('header')
  const [translations, setTranslations] = useState<{ lang: string, slug: string }[]>([])
  const [postId, setPostId] = useState<string | null>(null)
  const [sorryModalOpen, setSorryModalOpen] = useState<boolean>(false)

  async function load (id: string) {
    if (!user) return null
    const res = await PATHWAY.get(`/posts/${id}/translations`)
    setTranslations(res.data.data.translations)
    setPostId(id)
  }

  async function onLoad (slug: string) {
    if (!user) return null
    const res = await PATHWAY.get(`/posts?slug=${slug}`)

    const post = res.data.data.posts[0]
    if (!post) redirect('/404')

    await load(post.id)
  }

  useEffect(() => {
    if (user !== undefined) onLoad(params.slug)
  }, [user])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.title = 'Translations'
    }
  }, [])

  function findLanguage (lang: string): { lang: string, slug: string } | null {
    return translations.filter(tr => tr.lang === lang)[0] || null
  }

  return (
    <div className={styles.wrapper}>
      {[
        { short: 'en', key: 'global-languages.en' },
        { short: 'es', key: 'global-languages.es' },
        { short: 'my', key: 'global-languages.my' },
        { short: 'vi', key: 'global-languages.vi' },
        { short: 'he', key: 'global-languages.he' }
      ].map((lang, i) => {
        const record = findLanguage(lang.short)
        return (
          <Row
            key={i}
            lang={t(lang.key)}
            langShort={lang.short}
            exists={record !== null && !!record.slug}
            slug={record ? record.slug || null : null}
            postId={postId}
            isLoggedIn={!!user}
            openSorryModal={() => {
              setSorryModalOpen(!sorryModalOpen)
            }}
          />
        )
      })}
      <Dialog
        open={sorryModalOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setSorryModalOpen(false)}
        aria-describedby='alert-dialog-sorry'
      >
        <DialogTitle>{'Invalid Request'}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setSorryModalOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id='alert-dialog-sorry' style={{ minWidth: '300px', minHeight: '50px' }}>
            You must be logged in to do that
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Page
